import { Design } from 'apps/shared/scripts/__generated__/graphql.generated';
import { useCardDesigns } from 'apps/shared/scripts/graphql';
import { Carousel } from 'apps/shared/scripts/lib';

import Spinner from '../../Spinner';
import withControl, { WithControlRenderProps } from '../withControl';

import DesignGalleryItem from './DesignGalleryItem';
import { designGalleryClassName, loadingClassName } from './styles';

type Props = WithControlRenderProps;

const DesignGallery = ({ onChange, ref, value }: Props) => {
  const { isLoading, designs } = useCardDesigns();

  const list = designs.map((design: Design, i: number) => (
    <DesignGalleryItem
      key={i}
      design={design}
      isActive={design.id === value}
      onSelect={onChange}
    />
  ));

  if (isLoading) {
    return <div className={loadingClassName}><Spinner /></div>;
  }

  return (
    <div className={designGalleryClassName} ref={ref}>
      <Carousel>{list}</Carousel>
    </div>
  );
};

DesignGallery.displayName = 'DesignGallery';

export default withControl(DesignGallery);
